<template>
  <!--日志管理界面-->
  <div class="abnormal_data_page">
    <!-- 工具条 -->
    <el-form :inline="true" size="mini">
      <el-form-item>
        <el-select
          v-model="postdata.Param.UserId"
          placeholder="操作账号"
          @change="searchData"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in user"
            :key="index"
            :label="item.Name"
            :value="item.Id"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          placeholder="操作内容"
          v-model="postdata.Param.Content"
          @keyup.native.enter.stop="searchData"
          clearable
          @clear="searchData"
          filterable
        />
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="postdata.Typ"
          placeholder="操作类型"
          @change="searchData"
          filterable
        >
          <el-option
            v-for="(item,index) in logType"
            :key="index"
            :label="item.type"
            :value="item.value"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          type="daterange"
          v-model="dateRange"
          @change="searchData"
          value-format="timestamp"
          :default-time="['00:00:00','23:59:59']"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="searchData"
        >查询
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-download"
          @click="openExportSizeInput"
        >导出
        </el-button>
      </el-form-item>
    </el-form>
    <!-- 列表 -->
    <el-table
      :data="dataList"
      size="mini"
      border
      highlight-current-row
      :max-height="clientHeight"
      :loading="loading"
      style="width: 100%"
    >
      <el-table-column type="index" label="#" align="center" width="55"/>
      <el-table-column
        prop="UserName"
        width="230"
        align="center"
        label="操作账号"
        show-overflow-tooltip
        header-align="center"
      />
      <el-table-column
        prop="Content"
        label="操作内容"
        width="400"
        show-overflow-tooltip
        align="center"
      />
      <el-table-column
        prop="TypeName"
        label="操作类型"
        width="150"
        align="center"
      />
      <el-table-column
        prop="LogTime"
        label="操作时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="Ip"
        label="IP地址"
        align="center"
      />
    </el-table>
    <!-- 工具条 -->
    <el-col :span="24" class="toolbar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="postdata.page"
        :page-sizes="[ 20, 30, 50]"
        :page-size="postdata.Size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {export_json, parseTime} from '@/util/index'
import dayjs from 'dayjs'

export default {
  name: 'LogManage',
  data() {
    return {
      // 查询参数
      postdata: {
        page: 1,
        StartAt: 0, // 当前起始位置
        Size: 20, // 页面大小
        Typ: 0,
        Param: {
          StartAt: '',
          EndAt: '',
          Content: '',
          UserId: ''
        }
      },

      loading: false,
      // 日志类型
      logType: [{
        value: 0,
        type: '全部'
      }],
      // 数据列表
      dataList: [{
        value: 0,
        type: '全部'
      }],
      // 时间选择范围
      dateRange: [],
      total: 0,
      user: []
    }
  },
  computed: {
    ...mapState(['clientHeight']),
  },
  mounted() {
    this.init()

  },
  methods: {
    init() {
      if (this.$store.state.user.length === 0) {
        this.$get('admin/listAllUser').then(res => {
          this.user = res
          this.$store.dispatch('setUser', res)
          this.getLogType()
          this.getData() // 获取列表
        })
      } else {
        this.user = this.$store.state.user
        this.getLogType()
        this.getData() // 获取列表
      }

    },
    /**
     * @description 日期格式化
     */
    dateFormatter(row, column) {
      return parseTime(row[column.property], '{y}-{m}-{d}')
    },
    /**
     * @description 获取日志类型
     */
    getLogType() {
      this.$get('admin/listLogType')
        .then(res => {
          for (const resKey in res) {
            this.logType.push({
              value: parseInt(resKey),
              type: res[resKey]
            })
          }
        })
        .catch(e => {
          console.error(e)
        })
    },
    /**
     * @description 获取列表
     */
    getData() {
      this.loading = true
      this.postdata.StartAt = (this.postdata.page - 1) * this.postdata.Size
      this.$post('admin/listLog', this.postdata)
        .then((res) => {
          this.dataList = res.content
          this.total = res.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    /**
     * @description 查询
     */
    searchData() {
      this.postdata.page = 1
      if (this.dateRange && this.dateRange.length !== 0) {
        this.postdata.Param.StartAt = (this.dateRange[0]) / 1000
        this.postdata.Param.EndAt = (this.dateRange[1]) / 1000
      } else {
        this.postdata.Param.StartAt = ''
        this.postdata.Param.EndAt = ''
      }
      this.postdata.StartAt = 0
      this.getData()
    },
    /**
     * @description 导出
     */
    openExportSizeInput() {
      this.$prompt(`请输入导出的数据量（总量：${this.total} 条）`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: '只能填入数字'
      }).then(({value}) => {
        this.handleDownload(parseInt(value))
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        })
      })
    },
    handleDownload(value) {
      //定义加载中的动画
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        target: document.querySelector(".submit-dialog") // .submit-dialog 指的是 el-dialog 的 class
      });
      const temp = Object.assign({}, this.postdata)
      temp.Size = value
      temp.Param.IsDownload = true
      temp.StartAt = (this.postdata.page - 1) * this.postdata.Size
      this.$post('admin/listLog', temp)
        .then((res) => {
          let url = res.url
          const link = document.createElement('a')
          link.setAttribute('href', url)
          link.click()
          loading.close()
        })
        .catch((e) => {
          loading.close()
          console.error(e)
        })
    },
    /**
     * @description 每页条数
     */
    handleSizeChange(pageSize) {
      this.postdata.page = 1
      this.postdata.Size = pageSize
      this.getData()
    },

    /**
     * @description 页码
     */
    handleCurrentChange(page) {
      this.postdata.page = page
      this.getData()
    }
  }
}
</script>

<style lang="scss">
.abnormal_data_page {
  .page_box {
    padding: 30px 0;
    text-align: center;
  }
}
</style>
